import clsx from 'clsx'
import {CSSProperties, ReactElement} from 'react'

type OutlineButtonProps = {
  onClick?: () => void
  disabled?: boolean
  title: string | ReactElement
  className?: string
  center?: boolean
  fill?: boolean
  style?: CSSProperties
}
export const OutlineButton = ({
  onClick,
  disabled,
  title,
  className,
  center = false,
  fill = false,
  style,
}: OutlineButtonProps) => {
  const handleClick = () => {
    if (disabled) return
    onClick?.()
  }

  return (
    <div
      onClick={handleClick}
      style={style}
      className={clsx(
        'border rounded-pill px-2 py-1 border-primary-200 fw-bold',
        {
          'opacity-50 cursor-not-allowed': disabled,
          'cursor-pointer bg-hover-light': !disabled,
          'd-flex justify-content-center align-items-center': center,
          'align-self-end': !center,
          'text-primary-200': !fill,
          'text-white bg-primary-200 bg-hover-primary-200': fill,
        },
        className
      )}
    >
      {title}
    </div>
  )
}
